import * as React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChatPane from "./chatPane";

type Props = {
  open: boolean;
  onClose: () => void;
  leadId: string | number | null;
  providerName?: string | null;
};

export default function ProviderLeadChatDialog({
  open,
  onClose,
  leadId,
  providerName,
}: Props) {
  if (!leadId) return null;

  const title = providerName
    ? `Agent ↔ Provider — ${providerName}`
    : "Agent ↔ Provider";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pr: 6 }}>
        Conversation — Care Team
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
          size="small"
          aria-label="Close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        {/* Show the provider ↔ agent thread only */}
        <ChatPane
          leadId={String(leadId)}
          audience="PROVIDER" // <-- was mode="provider"
          viewerRole="PROVIDER"
          title={title} // <-- pass name here if you want it in the header
          height={520}
          pollMs={4000}
          // disableSubscription
        />
      </DialogContent>
    </Dialog>
  );
}
